// packages/hooks/useshops.ts (ou dans ton app)
import { shopService } from "@cabukaka/services";
import {  QueryFilters, Shop } from "@cabukaka/types";
import { useData } from "../core/useData";
import { useEffect, useState } from "react";

export function useShops( initialFilters?: QueryFilters) {
    // 1. On utilise le hook générique pour le gros du travail
    const { 
        data: shops, 
        loading, 
        error, 
        refresh, 
        deleteItem, 
        updateItem ,
        deleteManyItems
    } = useData<Shop>({
        ...shopService,
        ...shopService.baseService
    }, initialFilters);

  

    return {
        shops,
        loading,
        error,
        refresh,
        deleteShop: deleteItem,
        updateShop: updateItem,
        deleteManyShops: deleteManyItems
    };
}



export const useShopsBySector = (sectorSlug: string) => {
    const [shops, setShops] = useState<Shop[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!sectorSlug) return;

        const fetchShops = async () => {
            try {
                setLoading(true);
                const res = await shopService.getShopsBySectorSlug(sectorSlug);
                setShops(res.data || []);
            } catch (err) {
                setError("Erreur lors du chargement des boutiques");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchShops();
    }, [sectorSlug]);

    return { shops, loading, error };
};